import React from 'react';

import LazyLoad from 'bdvp-common/src/components/LazyLoad';
import Innings from '../../containers/Innings';

const LazyInnings = () => {

    return (
        <LazyLoad
            render={({
                elementRef,
                isVisible,
            }) => {

                return (
                    <div ref={elementRef}>
                        <Innings
                            skip={!isVisible}
                        />
                    </div>
                );

            }}
        />
    );

};

export default LazyInnings;
